import { marked } from 'marked';
import DOMPurify from 'dompurify';

// AI answers can carry text a customer wrote, so they keep only what markdown needs: no images, forms
// or styles that could load a URL the moment an answer shows.
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'a',
    'blockquote',
    'br',
    'code',
    'del',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'li',
    'ol',
    'p',
    'pre',
    'strong',
    'table',
    'tbody',
    'td',
    'th',
    'thead',
    'tr',
    'ul',
  ],
  ALLOWED_ATTR: ['align', 'href', 'start'],
  RETURN_DOM_FRAGMENT: true,
};
// Ziggu hosts other than the app itself, such as the help center
const ZIGGU_HOST_PATTERN = /(^|\.)ziggu\.(loc|dev|me|app)$/;

const urlParsed = (href) => {
  if (!href) return null;
  try {
    return new URL(href, window.location.href);
  } catch {
    return null;
  }
};

const isAppUrl = (url) => url.origin === window.location.origin;

// Links into the app stay in the tab, other Ziggu links open a new one, and any other link is shown as
// plain text.
const linkResolved = (link) => {
  const url = urlParsed(link.getAttribute('href'));
  if (url && isAppUrl(url)) return;
  if (url && ZIGGU_HOST_PATTERN.test(url.hostname)) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
    return;
  }
  link.replaceWith(...link.childNodes);
};

const renderMarkdown = (content) => {
  const fragment = DOMPurify.sanitize(marked.parse(content || ''), SANITIZE_CONFIG);
  fragment.querySelectorAll('a').forEach(linkResolved);
  const container = document.createElement('div');
  container.append(fragment);
  return container.innerHTML;
};

export { isAppUrl, renderMarkdown };
